import { ng } from '@uirouter/angularjs/lib/angular';
import * as angular from 'angular';
import { DefinitionsService } from '../../../../../../app.common/modules/common/services/definitions.service';
import { NotificationService } from '../../../../../../app.common/modules/common/services/notification.service';
import { PopupService } from '../../../../../../app.common/modules/common/services/popup.service';
import { RetailerChangeEmail } from '../../../../core';
import { AccountService } from '../../../account.service';

class ChangeRetailerEmail implements ng.IController {
    public static $inject = ['notificationService', 'popupService', 'accountService', 'definitionsService'];

    public currentEmail: string = null;
    public confirmEmail: string = null;
    public confirmPassword: string = null;
    public changeEmailForm: ng.IFormController;
    public changeEmail: RetailerChangeEmail = {
        Email: null,
        Password: null
    };
    public emailPattern: RegExp = this.definitionsService.regexEmail;
    public waiting: boolean;
    public modalInstance: ng.ui.bootstrap.IModalInstanceService = this as any;

    constructor(
        public notificationService: NotificationService,
        public popupService: PopupService,
        public accountService: AccountService,
        public definitionsService: DefinitionsService,
    ) {
    }

    public $onDestroy(): void {
        this.confirmEmail = null;
        this.changeEmail = null;
    }

    public changeEmailModel() {
        this.changeEmailForm.confirmEmail.$setValidity('match', this.changeEmail.Email === this.confirmEmail);
    }

    public closeDialog() {
        this.modalInstance.close();
    }

    public async updateEmail() {
        if (!this.changeEmailForm.$dirty && this.changeEmailForm.$invalid) {
            this.changeEmailForm.$setPristine();
            return;
        } else if (this.changeEmailForm.$dirty && this.changeEmailForm.$invalid) {
            return;
        }

        this.waiting = true;

        this.notificationService.showWaitingMessage();
        try {
            await this.accountService.updateEmail(this.changeEmail);
            this.notificationService.showSuccessMessage();
            this.modalInstance.close({$value: this.changeEmail.Email});
        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }
        this.waiting = false;
    }

}

angular.module('naut').component('changeRetailerEmail', {
    template: require('./change-retailer-email.component.html'),
    controller: ChangeRetailerEmail,
    controllerAs: 'ctrl',
    bindings: {
        resolve: '=',
        close: '&',
        dismiss: '&'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/account/components/profile/change-retailer-email/change-retailer-email.component.ts